/* eslint-disable react/jsx-no-target-blank */
import {useEffect} from 'react'
import {ILayout, useLayout} from '../../core'
import './Footer.scss'

const Footer = () => {
  const {config} = useLayout()
  useEffect(() => {
    updateDOM(config)
  }, [config])

  return (
    <div className="app-footer-content">
      <div className="footer-copyright">
        <span>© {new Date().getFullYear()} FB Zipper</span>
        <span className="footer-separator">|</span>
        <span>כל הזכויות שמורות</span>
      </div>

      <div className="footer-links">
        <a href="/terms" target="_blank">
          תנאי שימוש
        </a>
        <a href="/privacy" target="_blank">
          מדיניות פרטיות
        </a>
        <a href="/support">
          צור קשר
        </a>
      </div>
    </div>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true')
  }
}

export {Footer}
